import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";

export interface PortalSnackbarProps {
    message?: string;
    show?: boolean;
    autoHideDuration?: number;
    onClose?: () => void;
    severity?: "error" | "info" | "success" | "warning";
    clickToClose?: boolean;
}

const PortalSnackbar = (props: PortalSnackbarProps) => {
    const { message, show, autoHideDuration, onClose, severity, clickToClose } = props;

    const [open, setOpen] = useState<boolean>();

    useEffect(() => {
        setOpen(show);
    }, [show]);

    const handleClose = () => {
        setOpen(false);
        onClose?.();
    };

    return (
        <>
            {show && (
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    open={open}
                    autoHideDuration={autoHideDuration ?? 2000}
                    onClose={(_, reason) => {
                        if (reason)
                            if (clickToClose && reason === "clickaway") {
                                return;
                            } else {
                                handleClose();
                            }
                    }}
                >
                    <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
                        {message}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
};

export default PortalSnackbar;
